/**
 * ns.wow Extended Search
 * Facade class for public accessible plugin functionality.
 */

class Plugin {

  init() {

    let search = document.getElementById(NSContext.plugins.search.element);

    if (search !== null) {

      // Add popup box to show the linked notes

      document.body.insertAdjacentHTML('beforeend',
        `<div id="nswow-search-box">
                <div class="nswow-search-box__background"></div>
                  <div class="nswow-search-box__inner">
                    <div class="nswow-search-field__wrapper">
                      <input id="nswow-search-field" aria-label="Search input" type="search" placeholder="${NSContext.plugins.search.texts.placeholder}" autocomplete="off">
                    </div>
                    <div class="nswow-search-result__wrapper">
                      <div id="nswow-search-result">
                    </div>
                  </div>
                </div>
		          </div>`);

      // Click event for opening the popup box

      let timeout = null;
      let searchField = document.getElementById("nswow-search-field");

      // Listen for keystroke events
			searchField.addEventListener("keyup", (event) => {
				// Clear the timeout if it has already been set.
				// This will prevent the previous task from executing if it has been less than 1000ms
				clearTimeout(timeout);
				// Make a new timeout set to go off in 1000ms
				timeout = setTimeout(() => {
					if (searchField.value.length >= NSContext.plugins.search.limit) {
						// Open results in search template when Enter is pressed
						if (NSContext.plugins.search.forward && event.key === 'Enter') {
							window.location = NSContext.site.homeUrl + "?s=" + searchField.value;
						}
						// Show results in dropdown
						else {
							fetch( NSContext.site.restUrl + 'public/search?type=post&per_page=9999&lang=' + NSContext.language + '&search=' + searchField.value,
								{
									method : 'GET',
									headers: { 'X-WP-Token': NSContext.token },
								} )
								.then( ( response ) => {
									if ( response.status == '200' ) {
										return response.json();
									} else {
										let text = NSContext.plugins.search.texts.unknownError;
										if ( response.status == '401' ) {
											text = NSContext.plugins.search.texts.tokenExpired;
										}
										this.showMessage( text );
										return null;
									}
								} )
								.then( ( data ) => {
									if ( data != null ) {
										this.listResults( data );
									}
								} )
								.catch( ( exception ) => {
									this.showMessage( NSContext.plugins.search.texts.unknownError );
									console.log( 'ns.wow Extended Search: parsing error', exception );
								} );
						}
					} else {
						this.showMessage( NSContext.plugins.search.texts.lowerThanSearchLimit );
					}
				}, 1000);
			});

      // Show / hide

      const searchBox = document.getElementById("nswow-search-box");
      const background = document.querySelector(".nswow-search-box__background");

      search.onclick = function () {
        searchBox.classList.toggle('active');
				searchField.focus();
				searchField.select();
      }

      background.onclick = function () {
        searchBox.classList.toggle('active');
      }

    } else {
      console.log("ns.wow Extended Search: selector " + NSContext.plugins.search.element + " not found");
    }

  }

	showMessage(text) {
		let list = document.getElementById("nswow-search-result");
		list.innerHTML = '<div class="result-item"><div class="result-wrapper"><div class="result-title">' + text + '</div></div></div>';
	}

  listResults(data) {
    let html = "";
    let list = document.getElementById("nswow-search-result");
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        let title = data[i].title;
        let content = data[i].context;
        // Use highlighted result if option is set
        if (NSContext.plugins.search.highlight) {
          title = data[i].title_marked;
          content = data[i].context_marked;
        }
				// If the search term in not found in the post content it was found in the title or somewhere else.
				// In this case we ajust the count to 1 because we do have a match.
				let matchTotal = data[i].occurrences.total;
				let matchText = (matchTotal > 1) ? NSContext.plugins.search.texts.matches : NSContext.plugins.search.texts.match;
				html += '<div class="result-item">';
				html += '  <div class="result-wrapper">';
				html += '    <div class="result-title"><a href="' + data[i].url + '">' + title + '</a></div>';
				html += '    <div class="result-occurrences">' + matchTotal + ' ' + matchText + '</div>';
				if (NSContext.plugins.search.preview && data[i].occurrences.content > 0) {
					html += '    <div class="result-preview">' + content + '</div>';
				}
				html += '  </div>';
				html += '</div>';
      }
    } else {
      html += '<div class="result-item">';
      html += '  <div class="result-wrapper">';
      html += '    <div class="result-title">' + NSContext.plugins.search.texts.notfound + '</div>';
      html += '  </div>';
      html += '</div>';
    }
    list.innerHTML = html;
  }


}

export default new Plugin();
